<template>
  <div class="clear-both"></div>
  <div class="container">
    <div class="row">
      <div class="flex justify-between">
        <div class="w-1/2 p-4">
          <h2>api_config</h2>
          <div v-for="(link, key) in api_config" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">host {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="api_config[key].host" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">metric_config</h2>
          <div v-for="(link, key) in metric_config" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">host {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="metric_config[key].host" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5">service_links_support</h2>
          <div v-for="(link, key) in service_links_support" :key="'form-' + key">
            <div>
              <label :for="'input-' + key" class="form-label mt-5">host {{ key + 1}}</label>
              <input :id="'input-' + key" type="text" v-model="service_links_support[key].addres" class="form-input"/>
            </div>
          </div>
          <h2 class="mt-5 mb-3">service_links_referral</h2>
          <input type="text" v-model="service_links_referral.addres" class="form-input"/>

          <h2 class="mt-5 mb-3">service_links_account</h2>
          <input type="text" v-model="service_links_account.addres" class="form-input"/>

          <loading-button :loading="loading" @click="submitLink" class="mt-5 btn-indigo ml-auto">
            Save Domains
          </loading-button>
        </div>
        <div class="w-1/2 p-4">
          <pre>{{ jsonString }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {Head} from "@inertiajs/vue3";
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,
  },
  props: {
    config: Object,
    guid: String,
    appName: String,
  },
  layout: Layout,
  data() {
    return {
      loading: false,
      guid: this.guid,
      api_config: this.config.api_config.hosts,
      metric_config: this.config.metric_config.hosts,
      service_links_support: this.config.service_links.support,
      service_links_referral: this.config.service_links.referral,
      service_links_account: this.config.service_links.account,
    };
  },
  methods: {
    submitLink() {
      this.loading = true;
      axios.post('/api/config/update-batch', {
        data: {
          'api_config': {
            'hosts': this.api_config,
          },
          'metric_config': {
            'hosts': this.metric_config,
          },
          'service_links': {
            'support': this.service_links_support,
            'referral': this.service_links_referral,
            'account': this.service_links_account
          },
        },
        guid: this.guid,
        appName: this.appName
      })
          .then(response => {
            this.loading = false;
            alert(`Update is queued`);
          })
          .catch(error => {
            console.error(`Error saving ${key}:`, error);
            alert(`Failed to save ${key}.`);
          });
    },
    serialize(obj) {
      const result = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (typeof obj[key] !== 'function') {
            result[key] = obj[key];
          }
        }
      }
      return result;
    }
  },
  mounted() {
    console.log(this.config);
    console.log(this.config.service_links.account);
  },
  computed: {
    jsonString() {
      const dataForJson = this.serialize(this.config);
      return JSON.stringify(dataForJson, null, 2);
    }
  }
}
</script>
